<template>
	<Body class="page-search" />
	<BaseCmsPage>
		<BaseSearchResults :search-modules="[{module: 'catalog'}, {module: 'publish'}, {module: 'cms'}]" v-slot="{items, searchContent, searchTerm}">
            <div class="intro-container">
                <div class="wider-wrapper">
                    <div class="intro-container-inner">
                        <div class="page-search-intro">
                            <SearchTitleContainer :extraterm="searchTerm" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="search-layout">
                <div class="wider-wrapper">
                    <template v-if="searchContent == 'publish'">
                        <BasePublishPosts v-slot="{items, nextPage, loading, loadMore}">
                            <template v-if="items?.length">
                                <div class="p-items blog-cnt s-blog-cnt">
                                    <PublishIndexEntry v-for="post in items" :key="post.id" :item="post" :short-description="true" mode="search" />
                                </div>
                                <ClientOnly>
                                    <div class="load-more-container" v-if="nextPage">
                                        <UiLoader v-if="loading" />
                                        <button v-else type="button" class="btn load-more btn-secondary btn-load-more" @click="loadMore"><BaseCmsLabel code="load_more_publish" /></button>
                                    </div>
                                    <BaseUiPagination class="pagination" />
                                </ClientOnly>
                            </template>
                            <div v-else class="s-no-results">Nema rezultata za traženi pojam</div>
                        </BasePublishPosts>
                    </template>
                    <template v-if="searchContent == 'cms' && items?.cms">
                        <BaseCmsPage :fetch="{mode: 'search', 'search_q': searchTerm}" v-slot="{page}" :seo="false">
                            <div v-if="page.items?.length" class="s-items-cnt">
                                <article class="s-item" v-for="item in page.items" :key="item.id">
                                    <h2 class="s-item-title"><NuxtLink :to="item.url_without_domain">{{ item.title }}</NuxtLink></h2>
                                    <p v-if="item?.content" v-html="limitWords(stripHtml(item.content), 50)" />
                                </article>
                            </div>
                            <div v-else class="s-no-results">Nema rezultata za traženi pojam</div>
                        </BaseCmsPage>
                    </template>
                </div>
            </div>            		
		</BaseSearchResults>
	</BaseCmsPage>
</template>

<script setup>
    const {stripHtml, limitWords} = useText();
</script>

<style lang="less" scoped>
	.search-layout{padding-bottom: 80px;}
    .load-more-container{
		text-align: center; padding-top: 15px;
		.btn{min-width: 240px; margin: 0; }
	}
	:deep(.lds-ring){
		div{border-color: var(--primaryColor) transparent transparent transparent;}
	}

	@media (max-width: @t){
		.load-more-container{
			.btn{min-width: 200px; }
		}		
	}
	@media (max-width: @m){
		.load-more-container{
			.btn{min-width: 180px; padding: 0 12px;}
		}		
	}    
</style>
